// extracted by mini-css-extract-plugin
module.exports = {"boderTop":"index-module--boderTop--2tpZP","boder":"index-module--boder--c2XOF"};